import _objectWithoutProperties from "/workspace/services/growthhub/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import * as React from 'react';
import { memo } from 'react';
import { DndContext, createDndContext } from './DndContext';
/**
 * A React component that provides the React-DnD context
 */

export var DndProvider = memo(function (_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  var context = 'manager' in props ? {
    dragDropManager: props.manager
  } : createSingletonDndContext(props.backend, props.context, props.debugMode);
  return React.createElement(DndContext.Provider, {
    value: context
  }, children);
});
var instanceSymbol = Symbol.for('__REACT_DND_CONTEXT_INSTANCE__');

function createSingletonDndContext(backend) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getGlobalContext();
  var debugMode = arguments.length > 2 ? arguments[2] : undefined;
  var ctx = context;

  if (!ctx[instanceSymbol]) {
    ctx[instanceSymbol] = createDndContext(backend, context, debugMode);
  }

  return ctx[instanceSymbol];
}

function getGlobalContext() {
  return typeof global !== 'undefined' ? global : window;
}